const GECKO_INTERNAL_ROLE_PREFIX = 'gecko:internal:'

export function hasGeckoInternalRole(roleNames: readonly string[]): boolean {
  return roleNames.some((name) => name.startsWith(GECKO_INTERNAL_ROLE_PREFIX))
}
